/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, ViewChild, ElementRef, OnInit, HostListener, ViewChildren, QueryList, ViewEncapsulation } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalisationService } from '../../../core/services/localisation/zuper.localisation.service';
import { SearchService } from 'app/core/services/search/search.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';

@Component({
    selector: 'search-widget',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SearchWidgetComponent implements OnInit {
    activeIndex: number = -1;
    search: any = '';
    options: any[] = [];
    showPreview: boolean = false;
    setSearchKeywordField: Subscription;

    @ViewChild('searchWidgetInput') inputElement!: ElementRef;
    @ViewChildren('optionItems') searchResults!: QueryList<ElementRef>;

    private _unsubscribeAll: Subject<void> = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private _router: Router,
        public dialogRef: MatDialogRef<SearchWidgetComponent>,
        private searchService: SearchService,
        private _localStorageService: LocalStorageService,
        private localisationService: LocalisationService) {

    }

    ngOnInit(): void {
        //this.localisationService.setDefaultLanguage();
        this.setSearchKeywordField = this.searchService.setSearchKeywordField.subscribe((data: string) => {
            this.search = this.searchService.getSearchKeyValue(data) ?? '';
        });

        this.options = [
            {
              title: 'Create a Job',
              description: 'Add freeform text with basic formatting options.',
              icon: 'ti ti-briefcase'
            },
            {
              title: 'Create a Quote',
              description: 'Add freeform text with basic formatting options.',
              icon: 'ti ti-coin'
            },
            {
              title: 'Tom Cook',
              description: 'Add freeform text with basic formatting options.',
              icon: 'ti ti-coin'
            }
        ];
    }

    ngAfterViewInit() { 
        this.dialogRef.afterOpened().subscribe(() => {
            this.inputElement.nativeElement?.focus();
        });
    }

    // Navigation logic 
    @HostListener('document:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        //Ensure the list is focused
        // if (event.target !== this.searchResults?.first?.nativeElement?.closest('ul')) {
        //   return;
        // }
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                event.stopPropagation();
                this.navigateDown();
                break;
            case 'ArrowUp':
                event.preventDefault();
                event.stopPropagation();
                this.navigateUp();
                break;
            case 'Enter':
                event.preventDefault();
                event.stopPropagation();
                this.selectOption(this.activeIndex);
                break;
            default:
                return;
        }
    }

    navigateDown() {
        this.activeIndex = Math.min(
          this.activeIndex + 1, 
          this.options.length - 1
        );
        this.scrollToActiveItem();
    }

    navigateUp() {
        if(this.activeIndex === 0) {
            this.inputElement.nativeElement?.focus();
            this.activeIndex = -1;
        }
        else if(this.activeIndex !== -1){
            this.activeIndex = Math.max(this.activeIndex - 1, 0);
            this.scrollToActiveItem();
        }
    }

    scrollToActiveItem() {
        if(this.activeIndex == 2) {
            this.showPreview = true;
        }
        else {
            this.showPreview = false;
        }
        const activeElement = this.searchResults.toArray()[this.activeIndex].nativeElement;
        activeElement.focus();
    }

    selectOption(index: number) {
        console.log('Selected option:', this.options[index]);
        // Implement  selection logic here

        this.dialogRef.close();
    }

    getListItemClass(index: number) {
        return `
          group flex cursor-default select-none rounded-xl p-3 
          ${index === this.activeIndex ? 'bg-gray-100' : 'hover:bg-gray-100'}
        `;
    }

    trackbyFn(index: number, item: any) {
        return index;
    }

    redirectToSearchModule(): void {
        this.search = this.searchService.getSearchKeyValue(this.search);
        this._localStorageService.setLocalStorage('search_page_keyword', this.search);
        this.searchService.searchKeywordChanged.next(this.search);
        this._router.navigate(['/search']
            // ,{ queryParams: {'keyword': this.search}}
        );
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.setSearchKeywordField.unsubscribe();
        this.search = '';
    }
}
